import React from "react";
import cx from "classnames";
import ArticleCard from "../ArticleCard";

const ArticleCardContainer = ({ classNames, posts, topics, linkText }) => {
  return (
    <div className={cx("article-card-container row", classNames)}>
      {posts.map((post, i) => (
        <div
          className="article-card col-sm-6 col-lg-4 mb-4 d-flex align-items-stretch"
          key={`${post.slug}-${i}`}
        >
          <ArticleCard
            title={post.title}
            excerpt={post.excerpt}
            date={post.date}
            featuredImageNode={post.featuredImage?.node}
            tags={post.tags}
            categories={post.categories}
            topics={topics}
            linkText={
              <button
                className="button button-secondary button-rounded py-1"
                style={{ fontSize: "14px" }}
              >
                {linkText}
              </button>
            }
            linkTo={`/learn/${post.slug}/`}
          />
        </div>
      ))}
    </div>
  );
};

export default ArticleCardContainer;
